
<!--
	SweetModal for Vue.js
	Sweet, easy and powerful modals and dialogs

	Copyright (c) 2017 Adepto.as AS · Oslo, Norway
	Dual licensed under the MIT and GPL licenses.

	See LICENSE-MIT.txt and LICENSE-GPL.txt
-->
<div :class="overlay_classes" v-show="is_open" v-on:click="_onOverlayClick">
	<div :class="modal_classes" :style="modal_style">
		<div class="sweet-box-actions">
			<!-- Custom Actions -->
			<slot name="box-action"></slot>

			<!-- Close Button -->
			<div class="sweet-action-close" v-on:click="close" v-if="!hideCloseButton">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#292c34" /></svg>
			</div>
		</div>

		<!-- Title: Housing the title and tabs, if no title is present -->
		<div class="sweet-title" v-if="has_title || has_tabs">
			<!-- Tabs but no title -->
			<template v-if="has_tabs && !has_title">
				<ul class="sweet-modal-tabs">
					<li v-for="tab in tabs" :class="_getClassesForTab(tab)">
						<a href="#" v-on:click.prevent="_changeTab(tab)">
							<div class="sweet-modal-valign">
								<span v-if="tab.icon" v-html="tab.icon" class="sweet-modal-tab-icon" />
								<span class="sweet-modal-tab-title">{{ tab.title }}</span>
							</div>
						</a>
					</li>
				</ul>
			</template>

			<!-- Title -->
			<template v-if="has_title">
				<h2 v-if="title" v-html="title"></h2>
				<slot name="title"></slot>
			</template>
		</div>

		<!-- Tabs: If title AND tabs are present -->
		<ul class="sweet-modal-tabs" v-if="has_title && has_tabs">
			<li v-for="tab in tabs" :class="_getClassesForTab(tab)">
				<a href="#" v-on:click.prevent="_changeTab(tab)">
					<div class="sweet-modal-valign">
						<span v-if="tab.icon" v-html="tab.icon" class="sweet-modal-tab-icon" />
						<span class="sweet-modal-tab-title">{{ tab.title }}</span>
					</div>
				</a>
			</li>
		</ul>

		<!-- Content: Wrapper -->
		<div class="sweet-content" ref="content">
			<!-- Icon: Error -->
			<div class="sweet-modal-icon sweet-modal-error" v-if="icon == 'error'" ref="icon_error">
				<span class="sweet-modal-x-mark">
					<span class="sweet-modal-line sweet-modal-left"></span>
					<span class="sweet-modal-line sweet-modal-right"></span>
				</span>
			</div>

			<!-- Icon: Warning -->
			<div class="sweet-modal-icon sweet-modal-warning" v-if="icon == 'warning'" ref="icon_warning">
				<span class="sweet-modal-body"></span>
				<span class="sweet-modal-dot"></span>
			</div>

			<!-- Icon: Info -->
			<div class="sweet-modal-icon sweet-modal-info" v-if="icon == 'info'" ref="icon_info"></div>

			<!-- Icon: Success -->
			<div class="sweet-modal-icon sweet-modal-success" v-if="icon == 'success'" ref="icon_success">
				<span class="sweet-modal-line sweet-modal-tip"></span>
				<span class="sweet-modal-line sweet-modal-long"></span>
				<div class="sweet-modal-placeholder"></div>
				<div class="sweet-modal-fix"></div>
			</div>

			<!-- Actual Content -->
			<div class="sweet-content-content" v-if="$slots.default">
				<slot></slot>
			</div>
		</div>

		<!-- Buttons -->
		<div class="sweet-buttons" v-if="$slots.button">
			<slot name="button"></slot>
		</div>
	</div>
</div>
